import { MenuService, MenuAreaType } from 'app/services/menu.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';;
import { NavController } from '@ionic/angular';
import { ServiceMenuItem } from 'app/components/shared/header/header.popover';

import { Browser } from '@capacitor/browser';
import { Constants } from 'app/utility/constants';
import { StringHelper } from 'app/utility/stringhelper';

@Component({
    selector: 'app-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss'],
    standalone: false
})
export class MainMenuComponent implements OnInit
{
    @Input() area: MenuAreaType = 'dms';
    @Output() areaSelected = new EventEmitter<ServiceMenuItem>();

    constructor(
        private navCtrl: NavController,
        private menuService: MenuService
    )
    {

    }

    loginInfo = {
        customerNumber: '',
        username: ''
    }

    menuItems: ServiceMenuItem[];

    ngOnInit()
    {
        var menuitems = [];
        menuitems.push(new ServiceMenuItem("dms", "DMS", "dms", true));
        menuitems.push(new ServiceMenuItem("car-check", "Car Check", "carcheck", true));
        menuitems.push(new ServiceMenuItem("avanti-finance", "Avanti Finance", "finance", true, "avanti-finance-inverse"));
        menuitems.push(new ServiceMenuItem("buyerscore", "BuyerScore", "buyerscore", true));
        if (this.mcMinVersion("3.2.21"))
        {
            menuitems.push(new ServiceMenuItem("website-admin", "Website Admin", "website-admin", true));
        }
        menuitems.push(new ServiceMenuItem("vehiclexchange", "VehicleXchange", "wholesale", true));
        menuitems.push(new ServiceMenuItem("auto-attendant", "Auto Attendant", "autoattendant", true));
        // menuitems.push(new ServiceMenuItem("ampd-crm", "AMPD CRM", "https://www.motorcentral.co.nz/ampd", true));

        this.menuItems = menuitems;
    }

    currentMCVersion: string;

    mcMinVersion(version: string): boolean
    {
        if (!this.currentMCVersion)
        {
            this.currentMCVersion = localStorage.getItem(Constants.LocalStorage_MCDesktopVersion);
        }

        var versionCompare = this.version_compare(this.currentMCVersion, version, '>=');
        return versionCompare;
    }

    version_compare(v1: string, v2: string, operator: string): any
    {
        return StringHelper.versionCompare(v1, v2, operator);
    }

    // private ChunkArray(myArray: ServiceMenuItem[], chunk_size: number): any[]
    // {
    // 	var index = 0;
    // 	var arrayLength = myArray.length;
    // 	var serviceMenuItemRows = [];

    // 	for (index = 0; index < arrayLength; index += chunk_size)
    // 	{
    // 		var cols = myArray.slice(index, index + chunk_size);
    // 		serviceMenuItemRows.push(cols);
    // 	}

    // 	return serviceMenuItemRows;
    // }


    async loadTheLink(menuItem: ServiceMenuItem)
    {
        this.areaSelected.emit(menuItem);

        if (menuItem.area.startsWith("https"))
        {
            await Browser.open({ url: menuItem.area });
        }
        else if (menuItem.root)
        {
            let rootPath = await this.menuService.getRootPath(menuItem.area);
            this.navCtrl.navigateRoot('/' + rootPath);
        }
        else
        {
            this.navCtrl.navigateForward(menuItem.area);
        }
    }
}
